<h1 mat-dialog-title>Selected Scholarship Descriptions</h1>
<mat-dialog-content>
    @for (sch of data.scholarshipDescriptions; track sch.ScholarshipName) {
    <div>
        <strong>{{sch.ScholarshipName}}</strong>
        <p>{{sch.ScholarshipSummary}}</p>
    </div>
    }
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button type="button" (click)="closeDialog()">Close</button>
</mat-dialog-actions>